import * as React from "react";

const MoneyBillsIcon = (props) => (
  <svg
    width={72}
    height={72}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.1537 39.2311C38.0576 39.2311 36.2836 38.5052 34.8317 37.0533C33.3798 35.6014 32.6538 33.8273 32.6538 31.7312C32.6538 29.6351 33.3798 27.8611 34.8317 26.4092C36.2836 24.9573 38.0576 24.2313 40.1537 24.2313C42.2498 24.2313 44.0239 24.9573 45.4758 26.4092C46.9277 27.8611 47.6536 29.6351 47.6536 31.7312C47.6536 33.8273 46.9277 35.6014 45.4758 37.0533C44.0239 38.5052 42.2498 39.2311 40.1537 39.2311ZM18.1731 49.6157C16.9981 49.6157 15.9832 49.1883 15.1284 48.3335C14.2736 47.4787 13.8462 46.4638 13.8462 45.2888V18.1736C13.8462 16.9986 14.2736 15.9837 15.1284 15.1289C15.9832 14.2741 16.9981 13.8467 18.1731 13.8467H62.1343C63.3093 13.8467 64.3242 14.2741 65.179 15.1289C66.0338 15.9837 66.4612 16.9986 66.4612 18.1736V45.2888C66.4612 46.4638 66.0338 47.4787 65.179 48.3335C64.3242 49.1883 63.3093 49.6157 62.1343 49.6157H18.1731ZM23.7691 46.212H56.5384C56.5384 44.4004 57.1732 42.861 58.4429 41.5937C59.7126 40.3264 61.2508 39.6927 63.0575 39.6927V23.7696C61.246 23.7696 59.7066 23.1348 58.4393 21.8651C57.172 20.5954 56.5384 19.0572 56.5384 17.2505H23.7691C23.7691 19.062 23.1343 20.6014 21.8646 21.8687C20.5949 23.136 19.0567 23.7696 17.25 23.7696V39.6927C19.0615 39.6927 20.6009 40.3276 21.8682 41.5973C23.1355 42.867 23.7691 44.4052 23.7691 46.212ZM9.86547 57.9234C8.69047 57.9234 7.67557 57.496 6.82077 56.6412C5.96597 55.7863 5.53857 54.7714 5.53857 53.5965V24.4909C5.53857 24.0087 5.70307 23.6045 6.03207 23.2783C6.36107 22.9521 6.76875 22.789 7.2551 22.789C7.74145 22.789 8.14425 22.9521 8.4635 23.2783C8.7827 23.6045 8.9423 24.0087 8.9423 24.4909V53.5965C8.9423 53.8272 9.03847 54.0388 9.23082 54.2311C9.42312 54.4234 9.63467 54.5196 9.86547 54.5196H55.8171C56.2993 54.5196 56.7035 54.6841 57.0297 55.0131C57.3559 55.3421 57.519 55.7498 57.519 56.2362C57.519 56.7225 57.3559 57.1253 57.0297 57.4445C56.7035 57.7637 56.2993 57.9234 55.8171 57.9234H9.86547ZM18.1731 46.212H17.25V17.2505H18.1731C17.9231 17.2505 17.7067 17.3418 17.524 17.5245C17.3413 17.7072 17.25 17.9236 17.25 18.1736V45.2888C17.25 45.5388 17.3413 45.7551 17.524 45.9378C17.7067 46.1206 17.9231 46.212 18.1731 46.212Z"
      fill="url(#paint0_linear_1585_8875)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1585_8875"
        x1={66.4612}
        y1={19.1312}
        x2={0.430167}
        y2={44.7068}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#41B0F8" />
        <stop offset={0.505208} stopColor="#626DFD" />
        <stop offset={1} stopColor="#7232FB" />
      </linearGradient>
    </defs>
  </svg>
);

export default MoneyBillsIcon;
